// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".HeaderBlock-module-border-CziEA{border:1px solid #979797;border-radius:8px;padding:20px}@media(min-width: 768px){.HeaderBlock-module-border-CziEA{padding:30px}}.HeaderBlock-module-header-VcHCP{margin-bottom:10px}", ""]);
// Exports
exports.locals = {
	"border": "HeaderBlock-module-border-CziEA",
	"header": "HeaderBlock-module-header-VcHCP"
};
module.exports = exports;
